import React, { useEffect, useState } from 'react'
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faSearch,
    faTimes,
    faFilter,
    faShieldAlt,
    faCheckCircle,
    faClock,
    faMoneyBillWave,
    faInbox,
} from "@fortawesome/free-solid-svg-icons";
import "../ApplicationsDashboard/ApplicationsDashboard.css";
import "./InsuranceDashboard.css";
import SeedsLogo from "../../assets/images/SeedsLogo.png";
import { useDispatch, useSelector } from 'react-redux';
import CustomPagination from '../../components/Pagination/CustomPagination';
import Sidebar from '../../components/Sidebar/Sidebar';
import UserProfileDropdown from '../../components/UserProfile/UserProfile';
import { TiArrowSortedDown } from "react-icons/ti";
import DownloadPopup from './DownloadPopup/DownloadPopup';
import { getInsurancePremiumPaidLoans } from '../../redux/TrancheReducer/action';
import { toast } from 'react-toastify';
import axios from 'axios';
import { ERROR } from '../../redux/actionType';
import { isAuthorised } from '../../utils/common';
import { INSURANCE_COMPONENTS } from '../../config/insurance';

const InsuranceDashboard = () => {
    const navigate = useNavigate();
    const [isDownloadPopupOpen, setIsDownloadPopupOpen] = useState(false);
    const [dateFilter, setDateFilter] = useState({
        startDate: "",
        endDate: ""
    })

    const [isDownloadingInsuranceReport, setIsDownloadingInsuranceReport] = useState(false);

    const storedFilters = JSON.parse(sessionStorage.getItem('insuranceFilters')) || {};

    const [insuranceFilters, setInsuranceFilters] = useState({
        globalSearch: storedFilters?.globalSearch || ""
    })

    const { insurancePremiumPaidLoans, pagination, officerProfile } = useSelector((store) => {
        return {
            insurancePremiumPaidLoans: store.TrancheReducer.insurancePremiumPaidLoans.data,
            pagination: store.TrancheReducer.insurancePremiumPaidLoans.pagination,
            officerProfile: store.UserReducer.officerProfile
        }
    }, []);


    const dispatch = useDispatch();

    const [currentPage, setCurrentPage] = useState(parseInt(sessionStorage.getItem('currentPage')) || 1);
    const [limit, setLimit] = useState(parseInt(sessionStorage.getItem('limit')) || 10);
    const totalCount = parseInt(sessionStorage.getItem('totalCount')) || 0;
    const totalPages = Math.ceil(totalCount / limit);

    useEffect(() => {
        dispatch(getInsurancePremiumPaidLoans(currentPage, limit, insuranceFilters));

        sessionStorage.setItem('currentPage', currentPage);
        sessionStorage.setItem('limit', limit);
        // }, [dispatch, limit, currentPage, insuranceFilters]);
    }, [dispatch, limit, currentPage]);

    const handlePageChange = (newPage) => {
        // Ensure we're working with 1-based pagination
        const pageToSet = Math.max(1, Math.min(newPage, totalPages));
        setCurrentPage(pageToSet);
        sessionStorage.setItem('currentPage', pageToSet.toString());
    };

    const handleFilterChange = (e) => {
        let { name, value } = e.target;

        // Clean up accidental tabs/newlines and leading spaces from copy-pasting from tables
        if (typeof value === 'string') {
            value = value.replace(/[\t\n\r]+/g, '').replace(/^\s+/, '');
        }

        let updatedFilters = {
            ...insuranceFilters,
            [name]: value
        };

        setInsuranceFilters(updatedFilters);
        handlePageChange(1);
        sessionStorage.setItem("insuranceFilters", JSON.stringify(updatedFilters));
    }

    useEffect(() => {
        sessionStorage.setItem('currentPage', currentPage);
        sessionStorage.setItem('limit', limit);
    }, [limit, currentPage]);

    const formatDisplayDate = (dateStr) => {
        if (!dateStr) return "—";
        const date = new Date(dateStr);
        if (isNaN(date.getTime())) return dateStr;
        const months = [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
        ];
        return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
    };

    const formatCurrency = (val) => {
        if (val === null || val === undefined || val === "") return "—";
        const num = Number(val);
        if (isNaN(num)) return val;
        return `₹${num.toLocaleString('en-IN')}`;
    };

    const handleInsuranceReportDownload = async () => {
        let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
        let authToken = tokens?.token || null;

        if (!authToken) {
            return;
        }

        if (dateFilter.startDate && dateFilter.endDate &&
            dateFilter.startDate > dateFilter.endDate) {
            toast.error("Start date cannot be after end date");
            return;
        }

        // The export has to reflect what is on screen. It used to send only the
        // date range, so a search that was narrowing the table was dropped and
        // the CSV came back with every record instead of the filtered set.
        const queryParams = new URLSearchParams({ isDownload: true });
        const appendIfSet = (param, value) => {
            const val = typeof value === 'string' ? value.trim() : value;
            if (val) queryParams.append(param, val);
        };

        appendIfSet('startDate', dateFilter.startDate);
        appendIfSet('endDate', dateFilter.endDate);
        appendIfSet('globalSearch', insuranceFilters?.globalSearch);

        let headers = {
            'Authorization': `Bearer ${authToken}`
        }

        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/reports/get-insurance-premium-report?${queryParams.toString()}`, {
                headers,
                responseType: "blob"    // for CSV/PDF/Excel 
            });

            console.log("Response headers:", response.headers);
            console.log("Response raw data:", response.data);

            // const blob = await response.blob();
            const blob = new Blob([response.data], { type: "text/csv" });
            const blobUrl = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = blobUrl;
            link.setAttribute('download', `insurance_report_${new Date().toISOString()}.csv`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.log("Download Error: ", error);

            let errorMessage = "Download failed";

            try {
                // Attempt to parse the blob error message
                const reader = new FileReader();
                reader.onload = () => {
                    try {
                        const parsed = JSON.parse(reader.result);
                        errorMessage = parsed?.message || errorMessage;
                        console.log("erroorr: ", errorMessage);
                        toast.error(errorMessage);
                    } catch {
                        toast.error(errorMessage);
                    }
                };
                reader.readAsText(error.response.data);
            } catch {
                toast.error(errorMessage);
            }
        }
        finally {
            setIsDownloadingInsuranceReport(false);
            setIsDownloadPopupOpen(false);
            setDateFilter({
                startDate: "",
                endDate: ""
            })
        }
    }

    return (
        <div className="applicationsDashboardContainer">
            <div className="applicationsDashboard">
                <Sidebar />

                <div className="dashboardMainContent">
                    {/* --- Top Header --- */}
                    <div className="contentHeader">
                        <div className="userLogo">
                            <img src={SeedsLogo} alt="logo" className="SeedsLogo" />
                        </div>
                        <div className="headerRightPanel">
                            <UserProfileDropdown />
                        </div>
                    </div>

                    {/* --- Page Content --- */}
                    <div className="pageContentWrapper">
                        <div className="stickyHeaderContainer">
                            {/* Title */}
                            <div className="pageHeaderSection">
                                <div className="pageActions">
                                    <h2>Insurance</h2>

                                </div>
                            </div>


                            <DownloadPopup
                                showModal={isDownloadPopupOpen}
                                setShowModal={setIsDownloadPopupOpen}
                                dateFilter={dateFilter}
                                setDateFilter={setDateFilter}
                                handleDownload={handleInsuranceReportDownload}
                                isDownloading={isDownloadingInsuranceReport}
                            />



                            {/* --- Search & Filter Bar --- */}
                            {isAuthorised(
                                officerProfile,
                                INSURANCE_COMPONENTS?.insurance_search
                            ) && <div className="searchFilterBar insuranceSearchFilterBar">
                                    <div className="insuranceSearchGroup">
                                        <div className="searchInputWrapper">
                                            <FontAwesomeIcon icon={faSearch} className="searchIcon" />
                                            <input
                                                type="search"
                                                placeholder="Search by loan id, customer name, co-borrower name, branch name"
                                                name="globalSearch"
                                                value={insuranceFilters?.globalSearch}
                                                onChange={handleFilterChange}
                                                onInput={(e) => {
                                                    if (e.target.value === "") {
                                                        let updatedFilters = {
                                                            ...insuranceFilters,
                                                            globalSearch: e.target.value
                                                        }

                                                        setInsuranceFilters(updatedFilters)

                                                        dispatch(getInsurancePremiumPaidLoans(1, limit, updatedFilters));
                                                    }
                                                }}
                                            />
                                        </div>
                                        <button
                                            className="insuranceSearchBtn"
                                            onClick={() => {
                                                dispatch(getInsurancePremiumPaidLoans(1, limit, insuranceFilters, null));
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faSearch} />
                                            <span>Search</span>
                                        </button>
                                        <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                                        {isAuthorised(
                                            officerProfile,
                                            INSURANCE_COMPONENTS?.insurance_download
                                        ) && <button className="insuranceDownloadBtn" onClick={() => setIsDownloadPopupOpen(true)}>
                                                Download Report
                                                <TiArrowSortedDown style={{ width: "16px", height: "16px" }}/>
                                            </button>
                                        }
                                    </div>
                                    </div>
                                </div>}
                        </div>

                        {/* --- Data Table --- */}
                        <div className="tableCard">
                            <div className="applicationsTableContainer">
                                <table className="applications-table">
                                    <thead>
                                        <tr>
                                            <th>Loan ID</th>
                                            <th>Approval Amount</th>
                                            <th>Customer Name</th>
                                            <th>Borrower Gender</th>
                                            <th>Borrower DOB</th>
                                            <th>Borrower Phone Number</th>
                                            <th>Borrower PAN</th>
                                            <th>Borrower Educational Qualification</th>
                                            <th>Borrower Marital Status</th>
                                            <th>Co-borrower Name</th>
                                            <th>Co-borrower DOB</th>
                                            <th>Co-borrower Gender</th>
                                            <th>Co-borrower Phone Number</th>
                                            <th>Co-borrower PAN</th>
                                            <th>Co-Borrower Marital Status</th>
                                            <th>Borrower Address</th>
                                            <th>Borrower State</th>
                                            <th>Borrower District</th>
                                            <th>Borrower Pincode</th>
                                            <th>Co-Borrower Address</th>
                                            <th>Co-Borrower State</th>
                                            <th>Co-Borrower District</th>
                                            <th>Co-Borrower Pincode</th>
                                            <th>ROI</th>
                                            <th>Limit Valid Up To</th>
                                            <th>Limit Approved Details Date</th>
                                            <th>Branch Name</th>
                                            <th>Branch Code</th>
                                            <th>Gross Yearly Income</th>
                                            <th>Borrower Co-borrower Relation</th>
                                            <th>Loan Type</th>
                                            <th>Premium</th>
                                            <th>Processing Fee</th>
                                            <th>Processing Fee Received Date</th>
                                            <th>E-sign Created Date</th>
                                            <th>Current Residence Address</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            !insurancePremiumPaidLoans || insurancePremiumPaidLoans?.length === 0 ?
                                                <tr>
                                                    <td colSpan={37} className="insuranceNoDataCell">
                                                        <div className="insuranceNoDataContent">
                                                            <FontAwesomeIcon
                                                                icon={faInbox}
                                                                className="insuranceNoDataIcon"
                                                            />
                                                            <span className="insuranceNoDataTitle">
                                                                No records found
                                                            </span>
                                                            <span className="insuranceNoDataSubtitle">
                                                                Try adjusting your search criteria to find the insurance records you're looking for.
                                                            </span>
                                                        </div>
                                                    </td>
                                                </tr> :
                                                insurancePremiumPaidLoans?.map((loan, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            <span className="insuranceLoanIdLink">{loan?.loan_id}</span>
                                                        </td>
                                                        <td><span className="insuranceAmountCell">{formatCurrency(loan?.approval_amount)}</span></td>
                                                        <td>
                                                            <div className="stackedCell">
                                                                <span className="primaryText">{loan?.customer_name}</span>
                                                            </div>
                                                        </td>
                                                        <td>{loan?.borrower_gender}</td>
                                                        <td><span className="insuranceDateText">{formatDisplayDate(loan?.borrower_dob)}</span></td>
                                                        <td>{loan?.borrower_phone}</td>
                                                        <td>{loan?.borrower_pan}</td>
                                                        <td>{loan?.borrower_educational_qualification}</td>
                                                        <td>{loan?.borrower_marital_status}</td>
                                                        <td>{loan?.co_borrower_name}</td>
                                                        <td><span className="insuranceDateText">{formatDisplayDate(loan?.co_borrower_dob)}</span></td>
                                                        <td>{loan?.co_borrower_gender}</td>
                                                        <td>{loan?.co_borrower_phone}</td>
                                                        <td>{loan?.co_borrower_pan}</td>
                                                        <td>{loan?.co_borrower_marital_status}</td>
                                                        <td>{loan?.borrower_address}</td>
                                                        <td>{loan?.borrower_state}</td>
                                                        <td>{loan?.borrower_district}</td>
                                                        <td>{loan?.borrower_pincode}</td>
                                                        <td>{loan?.co_borrower_address}</td>
                                                        <td>{loan?.co_borrower_state}</td>
                                                        <td>{loan?.co_borrower_district}</td>
                                                        <td>{loan?.co_borrower_pincode}</td>
                                                        <td>{loan?.roi}</td>
                                                        <td>{loan?.limit_tenure}</td>
                                                        <td><span className="insuranceDateText">{formatDisplayDate(loan?.disbursement_date)}</span></td>
                                                        <td>
                                                            <div className="stackedCell">
                                                                <span className="primaryText">{loan?.branch_name}</span>
                                                                <span className="secondaryText">{loan?.branch_code}</span>
                                                            </div>
                                                        </td>
                                                        <td>{loan?.branch_code}</td>
                                                        <td><span className="insuranceAmountCell">{formatCurrency(loan?.gross_yearly_income)}</span></td>
                                                        <td>{loan?.borrower_co_borrower_relation}</td>
                                                        <td>{loan?.loan_type}</td>
                                                        <td><span className="insuranceAmountCell">{formatCurrency(loan?.premium)}</span></td>
                                                        <td><span className="insuranceAmountCell">{formatCurrency(loan?.pf_charges)}</span></td>
                                                        <td><span className="insuranceDateText">{formatDisplayDate(loan?.pf_charges_paid_date)}</span></td>
                                                        <td><span className="insuranceDateText">{formatDisplayDate(loan?.e_sign_created_at)}</span></td>
                                                        <td><span className="insuranceDateText">{formatDisplayDate(loan?.e_sign_completed_at)}</span></td>
                                                        <td>{loan?.current_residence_address}</td>
                                                    </tr>
                                                ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {/* --- Pagination --- */}
                        {(insurancePremiumPaidLoans?.length > 0) &&
                            <div className="paginationControls">
                                <CustomPagination
                                    currentPage={currentPage}
                                    totalPages={totalPages}
                                    onPageChange={handlePageChange}
                                />
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default InsuranceDashboard